export default class ImageHostMom {
  constructor() {
    this.GetImageUrlWithParams = _ref => {
      let {
        src,
        width,
        height,
        quality,
        backgroundColor,
        scaling = 1
      } = _ref;
      let urlString = src;
      let apiParams = '';
      if (width) {
        apiParams = apiParams.concat(`w=${width * scaling}&`);
      }
      if (height) {
        apiParams = apiParams.concat(`h=${height * scaling}&`);
      }
      if (quality) {
        apiParams = apiParams.concat(`q=${quality}&`);
      }
      if (backgroundColor) {
        apiParams = apiParams.concat(`b=0x${backgroundColor}&`);
      }

      // Append the parameters to the image URL
      if (apiParams.length > 0) {
        urlString = urlString.concat('?', apiParams).slice(0, -1); // remove trailing &
      }

      return urlString;
    };
  }
}